import clsx from "clsx";
import {isNull} from "lodash";


export function formatCentsPrice(cents) {
  if (isNull(cents))
    return "";

  return new Money(cents).toDollars();
}


export function agentFieldClassName({violated, focused=false}) {
  return clsx(
    "w-full p-1 my-1 border-2 text-right",
    (focused ? "border-agent-purple" : "border-white"),
    (violated ? "bg-red-100 text-red-800 border-red-800" :
      "bg-white text-agent-purple border-agent-purple")
  )
}

